import { render, staticRenderFns } from "./ReturnButton.vue?vue&type=template&id=f5ca65d6"
import script from "./ReturnButton.vue?vue&type=script&lang=js"
export * from "./ReturnButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports